<template>
  <v-btn
    class="btn"
    :color="color"
    :disabled="disabled"
    large="large"
    :block="block"
    depressed="depressed"
    :type="type"
    :loading="loading"
    @click.native="onClick($event)"
  >
    <span class="white--text btn--text">{{ text }}</span>
  </v-btn>
</template>

<script>
import BtnTemplate from './BtnTemplate.vue';

export default {
  name: 'BtnAddCrudList',
  extends: BtnTemplate,
  props: {
    color: {
      type: String,
      default: '#BD0E14',
    },
    iconColor: {
      type: String,
      default: 'white',
    },
  },
};
</script>
